import React from 'react';
import styled from 'styled-components';
import { PortableText, PortableTextReactComponents } from '@portabletext/react';
import type { TypedObject } from '@portabletext/types';
import sharedStyles from '@repo/ui-components/styles';

const Callout = styled.span`
  display: block;
  background: ${({ theme }) => theme.colors.callout};
  color: #262626;
  font-size: ${sharedStyles.fontSize['1xl']};
  font-weight: ${sharedStyles.fontWeight.bold};
  margin-bottom: 2rem;
  padding: 0.5rem;
  text-align: center;
`;

const AlphaList = styled.ol`
  ol > li {
    list-style-type: lower-alpha;
  }
`;

const TextIcon = styled.i`
  color: ${({ theme }) => theme.colors.brandPrimary};
  font-size: ${sharedStyles.fontSize.base};
`;

const components: Partial<PortableTextReactComponents> = {
  list: {
    number: ({ children }) => <AlphaList>{children}</AlphaList>,
  },
  types: {
    supportIcon: ({ value }) => <TextIcon className={value?.iconType} />,
    link: ({ value }) => <a href={value.href}>{value.caption}</a>,
  },
  marks: {
    callout: ({ children }) => <Callout>{children}</Callout>,
  },
};

interface SupportArticleTextProps {
  text?: {
    _type?: string;
  }[];
}

function SupportArticleText({ text }: Readonly<SupportArticleTextProps>) {
  return <PortableText value={text as TypedObject[]} components={components} />;
}

export default SupportArticleText;
